import { Debt } from '@axo/shared/data-access/types';
import { refinanceableDebtsTypes } from '../config/globals';

type GetRefinanceableDebtsParams = {
  debts?: Partial<Debt>[];
  translate: (key: string) => string;
};

export const getRefinanceableDebts = ({
  debts,
  translate,
}: GetRefinanceableDebtsParams) =>
  debts
    ?.filter(
      (debt) => debt.Type && refinanceableDebtsTypes?.includes(debt.Type)
    )
    ?.map((debt, index) => ({
      key: debt.ID ?? `${index}`,
      label: debt.Creditor as string,
      value: debt.OutstandingAmount ?? 0,
      step: 250,
      debtDescription: translate(`Debt.Type.${debt.Type}`),
      isChecked: true,
      isRefinanceable:
        debt.Type && refinanceableDebtsTypes?.includes(debt.Type),
    }));
